import { getProfile } from './getProfile';

/**
 * returns the active profile or undefined, if there are no profiles
 */
export const getActiveProfile = state =>
  getProfile(state)(state.profiles.active.id);
